import * as React from 'react';

import { PaywallTouchEventAdapter } from '~analytics/index';

import view from 'GoProView';
import modal from 'ModalController';
import platform from 'Platform';

class GoProController {
  render(props) {
    if (props) {
      new PaywallTouchEventAdapter(props.paywallScreen).sendAnalytics();
    }

    modal.render({
      modalWidth: '740',
      modalClass: 'go-pro-modal',
      content: React.createElement(view, {
        hideGoProButton: (props && props.hideGoProButton) || platform.isIosApp,
        goProButtonClicked: () => {
          modal.closeModal();
          props.router.routeToProfileBilling();
        },
      }),
    });
  }
}

let controller = new GoProController();
export default controller;
